import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ContainsSubscriptions } from '../../../../../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../../../../../core/pure-functions/rx-helper';
import { NumberFormatterService } from '../../../../../../../../core/services/number.formatter.service';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { ScreenType } from 'anchor-shared/lib/model/interface/add-edit-vessel-rate-per-hour-dialog-data';
import {
  RatePayee,
  VesselRate,
} from 'anchor-shared/lib/model/entity/vessel-rate';
import { RateType } from 'anchor-shared/lib/model/enum/vessel-rate-types';
import { getRateNameForCustomer } from 'anchor-shared/lib/service/pure-functions/get-vessel-rate-name';
import { VesselRateDAO } from '../../../../../../../../core/services/dao/vesselRateDAO';
import { UserDAO } from '../../../../../../../../core/services/dao/userDAO';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { User } from 'anchor-shared/lib/model/entity/user';
import { ChickenTestDialogService } from '../../../../../../../shared/dialogs/chicken-test-dialog/chicken-test-dialog.service';
import { PayoutEstimationData } from 'anchor-shared/lib/model/interface/payout-estimation-data';
import {
  AddOn,
  AddOnUnitType,
  DefinedAddOnType,
  RequiredAddOnUnitType,
} from 'anchor-shared/lib/model/entity/addOn';
import { AddOnUnitType2LabelMapping } from 'anchor-shared/lib/service/pure-functions/add-ons-helper/AddOnUnitType2LabelMapping';
import { CharterType } from 'anchor-shared/lib/model/enum/charter-type';
import { roundToNearestCent } from 'anchor-shared/lib/service/utils/helper';
import { AddEditVesselRatePerHourDialogData } from 'anchor-shared/lib/model/interface/add-edit-vessel-rate-per-hour-dialog-data';

const defaultAddOn = (vesselId, required = false): AddOn => ({
  vesselId,
  name: '',
  description: '',
  price: 0,
  markupPercentage: 0.2,
  unitType: AddOnUnitType.PER_HOUR,
  minQuantity: 0,
  maxQuantity: null,
  charterType: CharterType.DayCharter,
  required,
  ratePayee: RatePayee.BOAT_OWNER,
});

@Component({
  selector: 'app-add-edit-vessel-rate-per-hour-dialog',
  templateUrl: './add-edit-vessel-rate-per-hour-dialog.component.html',
  styleUrls: ['./add-edit-vessel-rate-per-hour-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddEditVesselRatePerHourDialogComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  public getRateNameForCustomer = getRateNameForCustomer;
  subs: Subscription[] = [];
  vessel: Vessel;
  screenType: string = 'case2';
  currencyMask: any;
  currencyMaskPerHour: any;
  percentageMask: any;
  pricePerPersonMask: any;
  ScreenType = ScreenType;
  depositAmount: number;
  hourlyRate: number;
  serviceFee: number;
  serviceFeePercent: number = 0.15;
  newVesselRatesByHour = {
    captainCount: 1,
    captainPrice: 100,
    crewCount: 1,
    crewPrice: 35,
    fuelIncluded: true,
    fuelPrice: 25,
    fuelBillingRate: 5.0,
    fuelReimbursementRate: 4.0,
    cleaningFee: 0,
  };
  cleaningFeeText: string = '$0';
  doNotAddCleaningFee: boolean = false;
  totalPayouts: number = 0;
  rentalIncome: number = 0;
  rentalIncomeClass: string = '';
  disableSaveButton: boolean = false;
  taxAmount: number;
  doNotChargeTax: boolean = false;
  applyTaxToRates: any[] = [];
  applyTaxToAll: boolean = true;
  fuelNotIncludedOnly: boolean = true;
  charterDuration: number = 4;
  payoutEstimations: PayoutEstimationData[] = [];
  payoutTotal: number = 0;
  ownerTotal: number = 0;
  hourOptions = [];
  guestCountOptions = [];
  guestCount;
  error: string;
  isAdmin: boolean;
  userOptions;
  filteredUsers;
  autoControl: FormControl = new FormControl();
  RatePayee = RatePayee;
  payeeOptions = [
    { value: RatePayee.BOAT_OWNER },
    { value: RatePayee.CAPTAIN },
    { value: RatePayee.CREW },
    {
      value: RatePayee.ANCHOR,
      adminOnly: true,
    },
    {
      value: RatePayee.SPECIFIC_USER,
      adminOnly: true,
    },
  ];
  addOn: AddOn;
  addOnErrors: { price: string; minQuantity: string; maxQuantity: string } = {
    price: null,
    minQuantity: null,
    maxQuantity: null,
  };
  isMobile: boolean;

  public AddOnUnitType2LabelMapping = AddOnUnitType2LabelMapping;

  public AddOnUnitTypes: AddOnUnitType[] = Object.values(
    AddOnUnitType,
  ) as AddOnUnitType[];

  constructor(
    public dialogRef: MatDialogRef<AddEditVesselRatePerHourDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddEditVesselRatePerHourDialogData,
    private numberFormatterService: NumberFormatterService,
    private readonly vesselRateDAO: VesselRateDAO,
    private userDao: UserDAO,
    private chickenTest: ChickenTestDialogService,
  ) {
    this.screenType = this.data.screenType;
    this.vessel = this.data.vessel;
    this.depositAmount = this.data.vessel.depositAmount;
    this.hourlyRate = parseFloat(this.vessel.hourlyRate.toFixed(2));
    this.serviceFee = parseFloat(
      (this.hourlyRate * this.serviceFeePercent).toFixed(2),
    );
    this.newVesselRatesByHour.fuelBillingRate = this.vessel.fuelBillingRate
      ? parseFloat(this.vessel.fuelBillingRate.toFixed(2))
      : 0.0;
    this.newVesselRatesByHour.fuelReimbursementRate = this.vessel
      .fuelReimbursementRate
      ? parseFloat(this.vessel.fuelReimbursementRate.toFixed(2))
      : 0.0;
    this.taxAmount = this.data.taxAmount;
    this.doNotChargeTax = this.taxAmount === 0;
    this.currencyMask = this.numberFormatterService.createPriceMask();
    this.currencyMaskPerHour =
      this.numberFormatterService.createPricePerHourMask();
    this.percentageMask = this.numberFormatterService.createPercentageMask();
    this.pricePerPersonMask =
      this.numberFormatterService.createPricePerPersonMask();
    this.addOn =
      this.data.addOn ||
      defaultAddOn(
        this.data.vesselId,
        this.screenType === ScreenType.EXTRA_GUEST_FEE,
      );
    this.isAdmin = this.data.isAdmin;
    this.isMobile = this.data.isMobile;
  }

  ngOnInit() {
    if (
      this.data.captainRates.length +
        this.data.crewRates.length +
        this.data.fuelRates.length >
      0
    ) {
      this.newVesselRatesByHour.captainPrice =
        this.newVesselRatesByHour.captainCount = 0;
      this.newVesselRatesByHour.crewCount =
        this.newVesselRatesByHour.crewPrice = 0;
      this.newVesselRatesByHour.fuelIncluded = false;
      this.newVesselRatesByHour.fuelPrice = 0;
    }
    if (this.data.captainRates.length) {
      this.newVesselRatesByHour.captainCount = this.data.captainRates.length;
      this.newVesselRatesByHour.captainPrice =
        this.data.captainRates[0].hourlyRate;
    }
    if (this.data.crewRates.length) {
      this.newVesselRatesByHour.crewCount = this.data.crewRates.length;
      this.newVesselRatesByHour.crewPrice = this.data.crewRates[0].hourlyRate;
    }
    if (this.data.fuelRates.length) {
      this.newVesselRatesByHour.fuelIncluded = true;
      this.newVesselRatesByHour.fuelPrice = this.data.fuelRates[0].hourlyRate;
    }
    if (this.data.cleaningRates.length) {
      this.newVesselRatesByHour.cleaningFee = parseFloat(
        (
          this.data.cleaningRates[0].customRate *
          (this.data.cleaningRates[0].markupPercentage + 1)
        ).toFixed(2),
      );
      this.cleaningFeeChange();
    } else {
      this.doNotAddCleaningFee = true;
    }
    if (this.data.addOn) {
      this.addOn = this.applyMarkupToAddOn(this.data.addOn);
    }
    this.newVesselRatesByHour.fuelIncluded = this.data.vessel.fuelIncluded;
    this.calculateHourTotals();
    this.addRatesToApplyTaxToRates();
    this.getPayouts();
    this.initHourOptions();
    this.initGuestCount();
    this.initUsers();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  initUsers() {
    const userSub = this.userDao.getUsersForPayouts().subscribe((data) => {
      this.userOptions = data;
      this.filteredUsers = this.autoControl.valueChanges.pipe(
        startWith(''),
        map((val) => (val && val.length >= 4 ? this._filter(val) : [])),
      );
      if (this.vessel.fuelPayeeUserId) {
        const initialUser = data.find(
          (x) => x.id === this.vessel.fuelPayeeUserId,
        );
        this.autoControl.setValue(
          `${initialUser.firstName} ${initialUser.lastName}`,
        );
      }
    });
    this.subs.push(userSub);
  }

  _filter(val: string): User[] {
    return this.userOptions.filter((s) =>
      new RegExp(val, 'gi').test(s.firstName + ' ' + s.lastName),
    );
  }

  selectUser(event, user: User) {
    if (event.isUserInput) {
      this.vessel.fuelPayeeUserId = user.id;
    }
  }

  getPayouts() {
    if (this.screenType === ScreenType.PAYOUT_ESTIMATION) {
      this.ownerTotal = this.payoutTotal = 0;
      const vesselPayoutEstimation = this.vesselRateDAO
        .vesselPayoutEstimation(this.vessel.id, this.charterDuration)
        .subscribe((payoutEstimation) => {
          this.payoutEstimations = payoutEstimation;
          payoutEstimation.map((payout) => {
            this.payoutTotal += payout.total;
            if (payout.payee === RatePayee.BOAT_OWNER) {
              this.ownerTotal += payout.total;
            }
          });
        });
      this.subs.push(vesselPayoutEstimation);
    }
  }

  addRatesToApplyTaxToRates() {
    this.vessel.vesselRates.map((rate) => {
      if (rate.rateType !== RateType.BookingFee) {
        this.applyTaxToRates.push({
          id: rate.id,
          name: this.getRateNameForCustomer(rate),
          addsTax: rate.taxPercentage > 0,
        });
        if (rate.taxPercentage <= 0 || rate.taxPercentage === null) {
          this.applyTaxToAll = false;
        }
      }
    });
  }

  fuelReimbursementRateUpdate() {
    let fuel = this.numberFormatterService.unMaskPricePerHour(
      this.newVesselRatesByHour.fuelBillingRate,
    );
    this.newVesselRatesByHour.fuelReimbursementRate = parseFloat(
      (fuel * 0.8).toFixed(2),
    );
    this.newVesselRatesByHour.fuelIncluded = false;
  }

  chargeCleaningFee() {
    if (this.doNotAddCleaningFee) {
      this.newVesselRatesByHour.cleaningFee = 0.0;
      this.cleaningFeeChange();
    }
  }

  chargeTax() {
    if (this.doNotChargeTax) {
      this.taxAmount = 0;
    } else {
      this.taxAmount = this.data.taxAmount;
    }
  }

  chargeTaxToAll() {
    if (this.applyTaxToAll) {
      this.applyTaxToRates.map((rate) => {
        rate.addsTax = true;
      });
    } else {
      this.applyTaxToRates.map((rate) => {
        rate.addsTax = false;
      });
      this.taxAmount = 0;
    }
  }

  checkFuelIncluded() {
    this.calculateHourTotals();
  }

  calculateHourTotals() {
    this.hourlyRate = this.vessel.hourlyRate =
      this.numberFormatterService.unMaskPricePerHour(this.hourlyRate);
    let total = 0;
    if (this.newVesselRatesByHour.captainCount === 0) {
      this.newVesselRatesByHour.captainPrice = 0;
    }
    let captainPrice = this.numberFormatterService.unMaskPricePerHour(
      this.newVesselRatesByHour.captainPrice,
    );
    total += captainPrice * this.newVesselRatesByHour.captainCount;
    if (this.newVesselRatesByHour.crewCount === 0) {
      this.newVesselRatesByHour.crewPrice = 0;
    }
    let crewPrice = this.numberFormatterService.unMaskPricePerHour(
      this.newVesselRatesByHour.crewPrice,
    );
    total += crewPrice * this.newVesselRatesByHour.crewCount;
    let fuelPrice = this.numberFormatterService.unMaskPricePerHour(
      this.newVesselRatesByHour.fuelPrice,
    );
    if (this.newVesselRatesByHour.fuelIncluded) {
      total += fuelPrice;
    }
    this.totalPayouts = parseFloat(total.toFixed(2));
    this.rentalIncome = parseFloat(
      (this.hourlyRate - this.serviceFee - this.totalPayouts).toFixed(2),
    );
    if (this.rentalIncome < 0) {
      this.rentalIncomeClass = 'app-booking-red';
      this.disableSaveButton = true;
    } else {
      this.rentalIncomeClass = '';
      this.disableSaveButton = false;
    }
  }

  unMaskPrices(): void {
    this.taxAmount = this.numberFormatterService.unMaskPercentage(
      this.taxAmount,
    );
    this.newVesselRatesByHour.captainPrice =
      this.numberFormatterService.unMaskPricePerHour(
        this.newVesselRatesByHour.captainPrice,
      );
    this.newVesselRatesByHour.crewPrice =
      this.numberFormatterService.unMaskPricePerHour(
        this.newVesselRatesByHour.crewPrice,
      );
    this.newVesselRatesByHour.fuelPrice =
      this.numberFormatterService.unMaskPricePerHour(
        this.newVesselRatesByHour.fuelPrice,
      );
    this.newVesselRatesByHour.fuelBillingRate =
      this.numberFormatterService.unMaskPrice(
        this.newVesselRatesByHour.fuelBillingRate,
      );
    this.newVesselRatesByHour.fuelReimbursementRate =
      this.numberFormatterService.unMaskPrice(
        this.newVesselRatesByHour.fuelReimbursementRate,
      );
  }

  validateWhatsIncluded() {
    if (
      Number(this.newVesselRatesByHour.fuelPrice) === 0 ||
      this.newVesselRatesByHour.fuelPrice.toString() === '$ 0/hr'
    ) {
      this.chickenTest
        .open(
          'Are you sure that you do not want to charge the customer for fuel rates?',
          'Yes',
          'Cancel',
          null,
          null,
          'Fuel included is set to $0',
        )
        .subscribe((confirmation) => {
          if (confirmation) {
            this.save();
          }
        });
    } else {
      this.save();
    }
  }

  handleAddOnsSave() {
    if (this.validateAddOn()) {
      this.save();
    }
  }

  validateAddOn() {
    if (
      this.addOn.name &&
      this.addOn.description &&
      this.addOn.price >= 0 &&
      this.addOn.price != null &&
      this.addOn.unitType &&
      this.addOn.minQuantity > 0 &&
      this.addOn.maxQuantity > 0 &&
      this.addOn.maxQuantity >= this.addOn.minQuantity
    ) {
      return true;
    } else {
      return false;
    }
  }

  deleteAddOn() {
    this.dialogRef.close({
      screenType: this.screenType,
      deleteAddOn: true,
      addOnId: this.addOn.id,
    });
  }

  cancel() {
    this.dialogRef.close(null);
  }

  save() {
    let updates: Partial<Vessel> = {};
    this.unMaskPrices();
    switch (this.screenType) {
      case ScreenType.DEPOSIT:
        updates['depositAmount'] = this.numberFormatterService.unMaskPrice(
          this.depositAmount,
        );
        break;
      case ScreenType.WHATS_INCLUDED:
        updates['hourlyRate'] = this.numberFormatterService.unMaskPricePerHour(
          this.hourlyRate,
        );
        updates['fuelIncluded'] = this.newVesselRatesByHour.fuelIncluded;
        updates['fuelReimbursementRate'] =
          this.newVesselRatesByHour.fuelReimbursementRate;
        updates['fuelBillingRate'] = this.newVesselRatesByHour.fuelBillingRate;
        updates['fuelNotIncludedOnly'] = this.fuelNotIncludedOnly;
        break;
      case ScreenType.FUEL_NOT_INCLUDED:
        updates['hourlyRate'] = this.numberFormatterService.unMaskPricePerHour(
          this.hourlyRate,
        );
        updates['fuelIncluded'] = this.newVesselRatesByHour.fuelIncluded;
        updates['fuelReimbursementRate'] =
          this.newVesselRatesByHour.fuelReimbursementRate;
        updates['fuelBillingRate'] = this.newVesselRatesByHour.fuelBillingRate;
        updates['fuelNotIncludedOnly'] = this.fuelNotIncludedOnly;
        break;
      case ScreenType.APPLY_TAXES:
        updates['taxAmount'] = this.taxAmount;
        break;
      case ScreenType.SELECT_TEXES:
        updates['taxAmount'] = this.taxAmount;
        break;
      case ScreenType.CLEANING_FEE:
        updates['cleaningFee'] = this.newVesselRatesByHour.cleaningFee;
        updates['doNotAddCleaningFee'] = this.doNotAddCleaningFee;
        break;
      case ScreenType.SELECT_PAYEE:
        if (
          this.vessel.fuelPayeeType === RatePayee.SPECIFIC_USER &&
          !this.vessel.fuelPayeeUserId
        ) {
          this.error = 'Please specify a user as payee.';
          return;
        }
        if (this.vessel.fuelPayeeType !== RatePayee.SPECIFIC_USER) {
          this.vessel.fuelPayeeUserId = null;
        }
        updates['fuelPayeeType'] = this.vessel.fuelPayeeType;
        updates['fuelPayeeUserId'] = this.vessel.fuelPayeeUserId;
        updates['hourlyRate'] = this.numberFormatterService.unMaskPricePerHour(
          this.hourlyRate,
        );
        updates['fuelIncluded'] = this.newVesselRatesByHour.fuelIncluded;
        updates['fuelReimbursementRate'] =
          this.newVesselRatesByHour.fuelReimbursementRate;
        updates['fuelBillingRate'] = this.newVesselRatesByHour.fuelBillingRate;
        updates['fuelNotIncludedOnly'] = this.fuelNotIncludedOnly;
        break;
      case ScreenType.OPTIONAL_ADD_ON:
        this.reduceAddOnByMarkup(this.addOn);
        updates['addOn'] = this.addOn;
        break;
      case ScreenType.EXTRA_GUEST_FEE:
        this.addOn.unitType = RequiredAddOnUnitType.PER_PERSON_ABOVE_LIMIT;
        this.addOn.name = DefinedAddOnType.EXTRA_GUEST_FEE;
        this.reduceAddOnByMarkup(this.addOn);
        updates['addOn'] = this.addOn;
        break;
    }

    this.dialogRef.close({
      screenType: this.screenType,
      vesselUpdates: updates,
      newVesselRatesByHour: this.newVesselRatesByHour,
      applyTaxToRates: this.applyTaxToRates,
    });
  }

  applyMarkupToAddOn(addOn) {
    addOn.price = roundToNearestCent(
      addOn.price * (1 + addOn.markupPercentage),
    );
    return addOn;
  }

  reduceAddOnByMarkup(addOn) {
    addOn.price = addOn.price / (1 + addOn.markupPercentage);
    return addOn;
  }

  goToNext(screenType: ScreenType) {
    if (screenType === ScreenType.FUEL_NOT_INCLUDED) {
      this.fuelNotIncludedOnly = false;
    }
    this.screenType = screenType;
  }

  modifyCaptainCount(add: number, minus: number, max?: number) {
    if (
      (add && max && this.newVesselRatesByHour.captainCount >= max) ||
      (minus && this.newVesselRatesByHour.captainCount <= 0)
    ) {
      return;
    }
    if (add) {
      this.newVesselRatesByHour.captainCount += add;
    } else {
      this.newVesselRatesByHour.captainCount -= minus;
    }
    this.calculateHourTotals();
  }

  modifyCrewCount(add: number, minus: number, max?: number) {
    if (
      (add && max && this.newVesselRatesByHour.crewCount >= max) ||
      (minus && this.newVesselRatesByHour.crewCount <= 0)
    ) {
      return;
    }
    if (add) {
      this.newVesselRatesByHour.crewCount += add;
    } else {
      this.newVesselRatesByHour.crewCount -= minus;
    }
    this.calculateHourTotals();
  }

  taxChange() {
    this.taxAmount = this.numberFormatterService.unMaskPercentage(
      this.taxAmount,
    );
    if (this.taxAmount > 0) {
      this.doNotChargeTax = false;
    } else {
      this.doNotChargeTax = true;
    }
  }

  cleaningFeeChange() {
    this.newVesselRatesByHour.cleaningFee =
      this.numberFormatterService.unMaskPrice(
        this.newVesselRatesByHour.cleaningFee,
      );
    this.cleaningFeeText = `$${parseFloat(
      (this.newVesselRatesByHour.cleaningFee * 0.8).toFixed(2),
    )}`;
  }

  extraGuestFeeChange(event) {
    this.addOn.price = this.numberFormatterService.unMaskPrice(
      this.addOn.price,
    );
    if (this.addOn.minQuantity === 0) {
      this.addOn.minQuantity = 1;
    }
  }

  initGuestCount() {
    for (let i = 0; i < this.vessel.numOfPassengers; ++i) {
      this.guestCountOptions.push(i + 1);
    }
    this.guestCount = this.vessel.numOfPassengers;
  }

  decrementExtraGuestCount() {
    if (this.addOn.minQuantity > 1) {
      this.addOn.minQuantity -= 1;
    }
  }

  incrementExtraGuestCount() {
    if (this.addOn.minQuantity <= (this.vessel.numOfPassengers || 1)) {
      this.addOn.minQuantity += 1;
    }
  }

  handleNoExtraGuestFee({ checked }) {
    if (checked) {
      this.addOn.price = 0;
      this.addOn.minQuantity = 0;
    } else {
      this.addOn.minQuantity = 1;
    }
  }

  initHourOptions() {
    this.hourOptions = [
      {
        key: '1 hour',
        value: 1,
      },
      {
        key: '2 hours',
        value: 2,
      },
      {
        key: '3 hours',
        value: 3,
      },
      {
        key: '4 hours',
        value: 4,
      },
      {
        key: '5 hours',
        value: 5,
      },
      {
        key: '6 hours',
        value: 6,
      },
      {
        key: '7 hours',
        value: 7,
      },
      {
        key: '8 hours',
        value: 8,
      },
      {
        key: '9 hours',
        value: 9,
      },
      {
        key: '10 hours',
        value: 10,
      },
      {
        key: '11 hours',
        value: 11,
      },
      {
        key: '12 hours',
        value: 12,
      },
    ];
  }
}
